export default __webpack_public_path__ + "static/media/folder.cdf5b278.svg";